<div class="center-align">

    <sh-text class="font-header-1">Specification(<span *ngIf="experiencedMode">Experienced</span><span
            *ngIf="!experiencedMode">Basic</span>)</sh-text>
</div>

<div class="font-size-10">
    <span class="assetPath-span"
        *ngFor="let path of assetPath?.split(','); let i = index">
        <b id="textAssetPath" *ngIf="i < assetPath?.split(',').length-1; else orangeText">{{path}}
            <sh-icon icon="play" class="assetPath-icon">
            </sh-icon>
        </b>
        <ng-template #orangeText>
            <b class="font-orrange">{{path}}</b>
        </ng-template>
    </span>
</div>
<br>
<sh-grid fit-content *ngIf="asset.attributes" id="asset-attributes">
    <div columns="7">
        <div *ngIf="showEdit && renameEnable" class="asset-attribute">
            <sh-input-text label='Asset Name' [value]="editedAssetName"
                (value-changed)="editedAssetName= $event.target.value !== ''? $event.target.value : editedAssetName"
                id="renameAsset" [error]="assetNameError || assetNameExists"></sh-input-text>
            <sh-icon class="notify-icon" button color="secondary" icon="success" id="success"
                (click)="renameAsset()"></sh-icon>
            <sh-icon class="notify-icon" button icon="error" id="cancel"
                (click)="renameEnable = false;assetNameError = false; assetNameExists = false"></sh-icon>
            <sh-tooltip *ngIf="assetNameError" label="Please enter the Asset Name" target="renameAsset"
                placement="bottom-left" variation="short"></sh-tooltip>
            <sh-tooltip *ngIf="assetNameExists"
                label="The entered Asset Name (case insensitive) exists. Please enter a different Asset Name"
                target="renameAsset" placement="bottom-left" variation="short"></sh-tooltip>
        </div>
        <span class="rename-asset-span"></span>
        <sh-text *ngIf="!renameEnable" class="font-orrange rename-asset">
            {{assetPath?.split(',')[assetPath?.split(',').length-1]}}</sh-text>
        <sh-icon button icon="edit" *ngIf="showEdit && !renameEnable" class="rename-asset-icon"
            (click)="renameEnable = true"></sh-icon>
        <sh-dropdown *ngIf="versionList && versionList.length > 0 && !renameEnable" id="dropdowntextture"
            label='Version' [value]=selectedVersion>
            <sh-menu-item *ngFor="let v of versionList;let i = index" id="h{{i}}"
                label="{{v.version}}{{v.deleted ? ' - deleted' : ''}}"
                (click)="selectedVersion = v.version; changeVersion(v.version)" [disabled]="v.deleted"></sh-menu-item>
        </sh-dropdown>

    </div>
    <div columns="5">

        <sh-grid>
            <div columns="7">

                <svg height="16" width="16" *ngIf="asset.attributes.productStatus === 0">
                    <circle cx="10" cy="10" r="6" fill="#efdd59" />
                </svg>
                <svg height="16" width="16" *ngIf="asset.attributes.productStatus === 1">
                    <circle cx="10" cy="10" r="6" fill="#57EE1E" />
                </svg>
                <span>
                    <sh-text class="product-status">
                        {{asset.attributes.productStatus | productStatus}}
                    </sh-text>
                </span>
            </div>
            <div columns="1"></div>
            <div columns="4" class="subscribe-icon" (click)="inform(asset)"
                id="divSubscribe">
                <svg *ngIf="!asset.inform" class="heart" viewBox="0 0 32 29.6">
                    <path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
                              c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z" />
                </svg>
                <svg *ngIf="asset.inform" class="heart-selected" viewBox="0 0 32 29.6">
                    <path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
                              c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z" />
                </svg><br>
                <sh-text class="font-header-1">Keep me informed</sh-text>
            </div>
        </sh-grid>
    </div>
    <div columns="12">
        <sh-grid class="download-threed-modal">
            <div columns="2">
                <sh-checkbox label='3D-Model' class="pointer-events-none" id="cb3DFile"
                    [active]="selectedAsset.specification.fileType === '3D'"></sh-checkbox>
            </div>
            <div columns="10">
                <sh-grid>
                    <div *ngIf="experiencedMode" columns="4">
                        <sh-text class="font-body-2">Quality</sh-text>
                        <sh-radio-group [value]=selectedAsset.specification.fileQuality
                            (value-changed)="selectedAsset.specification.fileQuality=$event.target.value">

                            <sh-radio-button id="rbFileHigh" label="High"
                                [active]="selectedAsset.specification.fileQuality === 0"
                                (click)="selectAssetOnFileQuality(0, selectedAsset.specification.textureQuality)"
                                [disabled]="quality.indexOf(0) < 0"></sh-radio-button>
                            <sh-radio-button id="rbFileMedium" label="Medium"
                                [active]="selectedAsset.specification.fileQuality === 1"
                                (click)="selectAssetOnFileQuality(1, selectedAsset.specification.textureQuality)"
                                [disabled]="quality.indexOf(1) < 0"></sh-radio-button>
                            <sh-radio-button id="rbFileLow" label="Low"
                                [active]="selectedAsset.specification.fileQuality === 2"
                                (click)="selectAssetOnFileQuality(2, selectedAsset.specification.textureQuality)"
                                [disabled]="quality.indexOf(2) < 0"></sh-radio-button>
                        </sh-radio-group>
                    </div>
                    <div *ngIf="experiencedMode" columns="4">
                        <sh-text class="font-body-2">File Format</sh-text>
                        <sh-radio-group>
                            <sh-radio-button id="rbFileFormat" *ngFor="let f of formats" label=".{{f}}"
                                [active]="selectedAsset.specification.fileFormat === f"
                                (click)="selectedAsset.specification.fileFormat = f; qualityForSelectedFormat(f)">
                            </sh-radio-button>

                        </sh-radio-group>
                    </div>
                </sh-grid>
            </div>
            <div columns="2">
                <sh-checkbox label='Texture' class="pointer-events-none" active id="cbTexture"></sh-checkbox>
            </div>
            <div columns="10">
                <sh-grid>
                    <div *ngIf="experiencedMode" columns="4">
                        <sh-text class="font-body-2">Quality</sh-text>
                        <sh-radio-group>

                            <sh-radio-button id="rbTextureHigh" label="High"
                                [active]="selectedAsset.specification.textureQuality=== 0"
                                (click)="selectAssetOnTextureQuality(selectedAsset.specification.fileQuality,0)"
                                [disabled]="textureQuality.indexOf(0) < 0"></sh-radio-button>
                            <sh-radio-button id="rbTextureMedium" label="Medium"
                                [active]="selectedAsset.specification.textureQuality === 1"
                                (click)="selectAssetOnTextureQuality(selectedAsset.specification.fileQuality,1)"
                                [disabled]="textureQuality.indexOf(1) < 0"></sh-radio-button>
                            <sh-radio-button id="rbTextureLow" label="Low"
                                [active]="selectedAsset.specification.textureQuality === 2"
                                (click)="selectAssetOnTextureQuality(selectedAsset.specification.fileQuality,2)"
                                [disabled]="textureQuality.indexOf(2) < 0"></sh-radio-button>
                        </sh-radio-group>
                    </div>
                </sh-grid>
            </div>
            <div columns="2" class="container">

                <sh-checkbox *ngIf="selectedAsset.specification.rigged||experiencedMode" id="cbRigged" label='Rigged'
                    [active]=selectedAsset.specification.rigged class="pointer-events-none"></sh-checkbox>

            </div>
            <div columns="10">
                <sh-grid>
                    <div columns="4">
                        <sh-checkbox id="cbAnimation" *ngIf="selectedAsset.specification.animation||experiencedMode"
                            label='Animation' [active]=selectedAsset.specification.animation class="pointer-events-none"></sh-checkbox>

                    </div>
                </sh-grid>
            </div>
            <div columns="2">
                <sh-checkbox label='Moment Logic' disabled
                    *ngIf="selectedAsset.specification.movementLogic||experiencedMode" id="cbMovement"
                    [active]=selectedAsset.specification.movementLogic class="pointer-events-none"></sh-checkbox>
            </div>
            <div columns="10">
                <sh-checkbox disabled label='User Interaction'
                    *ngIf="selectedAsset.specification.userInteraction||experiencedMode" id="cbUserInteraction"
                    [active]=selectedAsset.specification.userInteraction class="pointer-events-none"></sh-checkbox>
            </div>
            <div columns="2">

            </div>
            <div columns="10">
                <sh-grid>
                    <div columns="4">


                    </div>
                </sh-grid>
            </div>
            <div columns="4">
                <sh-checkbox disabled label='Automaticaly update via GIT' class="pointer-events-none"
                    *ngIf="selectedAsset.specification.automaticallyUpdateViaGit||experiencedMode" id="cbUpdatedViaGit"
                    [active]=selectedAsset.specification.automaticallyUpdateViaGit></sh-checkbox>
            </div>

            <div columns="12">
                <app-rating></app-rating>
            </div>

            <div columns="12">
                <sh-grid>
                    <div columns="6"></div>
                    <div columns="6" class="float-right">

                        <sh-button class="spec-btn" shape="pill-m" label='Download'
                            (click)="download()" id="btndownload"></sh-button>
                        <sh-button class="spec-btn" color="secondary" *ngIf="showEdit"
                            shape="pill-s" label='Modify' id="modifyAsset"
                            onclick="document.getElementById('my-modal').setAttribute('visible', 'true')"
                            (click)="modifyAsset()"></sh-button>
                        <sh-button class="spec-btn" color="secondary" *ngIf="showEdit"
                            shape="pill-s" id="deleteAsset" label='Delete' (click)="deleteConfirmationPopUp()">
                        </sh-button>

                    </div>
                </sh-grid>
            </div>
            <div columns="12">
                <hr>
            </div>
            <div columns="12">
                <sh-button *ngIf="!showAddCommentDiv" shape="pill-m" color="secondary" label='Add Comment'
                    id="addComment" (click)="showAddComment()"></sh-button>
            </div>
            <div columns="12" *ngIf="showAddCommentDiv">
                <sh-input-text label='Subject' id="commentSubject" [(value)]="newComment.subject"
                    (value-changed)="newComment.subject=$event.target.value" [error]="commentSubjectError"
                    (blur)="commentSubjectError = (newComment.subject === '' || newComment.subject.trim() === '')">
                </sh-input-text>
                <br />
                <sh-tooltip *ngIf="commentSubjectError" label="Please enter the Comment Subject" target="commentSubject"
                    placement="bottom-right" variation="short"></sh-tooltip>
                <sh-input-text label='Comment' textarea="true" id="commentDescription"
                    [(value)]="newComment.description" (value-changed)="newComment.description=$event.target.value"
                    [error]="commentDescriptionError" [error]="commentDescriptionError"
                    (blur)="commentDescriptionError = (newComment.description === '' || newComment.description.trim() === '')">
                </sh-input-text>
                <sh-tooltip *ngIf="commentDescriptionError" label="Please enter the Comment Description"
                    target="commentDescription" placement="bottom-right" variation="short"></sh-tooltip>
                <div columns="12" class="float-right">
                    <div class="add-cancel-btn">
                        <sh-grid>
                            <sh-button shape="pill-s" color="secondary" label='Cancel' columns="5" id="cancel"
                                (click)="showAddCommentDiv=false"></sh-button>
                            <sh-button shape="pill-s" label='Add' id="add" columns="7" (click)="addComment()">
                            </sh-button>
                        </sh-grid>
                    </div>
                </div>
            </div>
            <div columns="12" class="load-comment">
                <app-comments [comments]="asset.comments">Loading...</app-comments>
            </div>
        </sh-grid>
    </div>

</sh-grid>

<div *ngIf="asset">
    <sh-modal id="my-modal" label="Modify" *ngIf="updateText === 'Modify'" (modal-closed)="cancelEdit()">
        <div *ngIf="edit">

            <sh-input-text label='Primary Contact Name' name="pcName" ngDefaultControl
                [value]="asset.attributes.primaryContact.name"
                (value-changed)="asset.attributes.primaryContact.name=$event.target.value"
                [formControl]="primaryContactNameControl" [error]="primaryContactNameControl.invalid" id="pcName">
            </sh-input-text>
            <sh-tooltip *ngIf="primaryContactNameControl.invalid" label="Please enter the Primary Contact Name"
                target="pcName" placement="bottom-right" variation="short"></sh-tooltip>

            <br>

            <sh-input-text label='Primary Contact Email Address' name="pcEmail" ngDefaultControl
                [value]="asset.attributes.primaryContact.emailId"
                (value-changed)="asset.attributes.primaryContact.emailId=$event.target.value"
                [formControl]="primaryContactEmailControl" [error]="primaryContactEmailControl.invalid" id="pcEmail">
            </sh-input-text>
            <sh-tooltip *ngIf="primaryContactEmailControl.hasError('required')"
                label="Please enter the Primary Contact Email Id" target="pcEmail" placement="bottom-right"
                variation="short"></sh-tooltip>
            <sh-tooltip
                *ngIf="primaryContactEmailControl.hasError('pattern') || primaryContactEmailControl.hasError('email')"
                label="Please enter a valid Primary Contact Email Id" target="pcEmail" placement="bottom-right"
                variation="short"></sh-tooltip>

            <br>
            <br>
            <div class="outilne">
                <sh-radio-group>
                    <p class="outline">Product Status</p>
                    <sh-radio-button label="Not Commercially Ready" id="productstatus1"
                        [active]="asset.attributes.productStatus == 0" (click)="asset.attributes.productStatus = 0">
                    </sh-radio-button>
                    <sh-radio-button class="pointer-events-none" label="Commercially Ready" [active]="asset.attributes.productStatus == 1"
                        (click)="asset.attributes.productStatus = 1" disabled></sh-radio-button>
                </sh-radio-group>
            </div>

            <div class="outline">

                <p class="outline">Specifications</p>
                <div class="assetDetailsGrid">
                    <sh-checkbox label='Rigged' id="cbspecificationrigged" [active]="assetFileSpecifaction.rigged"
                        (click)="changeCheckBoxValue(assetFileSpecifaction,'rigged')"></sh-checkbox>
                    <sh-tooltip
                        label="Rigged: In its simplest form, 3D rigging is the process of creating a skeleton for a 3D model so it can move. Most commonly, characters are rigged before they are animated because if a character model doesn't have a rig, they can't be deformed and moved around"
                        target="cbspecificationrigged" placement="bottom-right" variation="short"></sh-tooltip>
                    <sh-checkbox label='Animation' id="cbspecificationanimation"
                        [active]="assetFileSpecifaction.animation"
                        (click)="changeCheckBoxValue(assetFileSpecifaction,'animation')"></sh-checkbox>
                    <sh-tooltip
                        label="Animation: Animating objects that appear in a three-dimensional space. They can be rotated and moved like real objects. 3D animation is at the heart of games and virtual reality, but it may also be used in presentation graphics to add flair to the visuals."
                        target="cbspecificationanimation" placement="bottom-right" variation="short"></sh-tooltip>
                    <sh-checkbox disabled label='Movement Logic' [active]="assetFileSpecifaction.movementLogic"
                        id="cbspecificationmovement"
                        (click)="changeCheckBoxValue(assetFileSpecifaction,'movementLogic')"></sh-checkbox>

                    <sh-checkbox disabled label='User Interaction' [active]="assetFileSpecifaction.userInteraction"
                        id="cbspecificationuserInteraction"
                        (click)="changeCheckBoxValue(assetFileSpecifaction,'userInteraction')"></sh-checkbox>
                    <sh-checkbox disabled label='Update Via Git'
                        [active]="assetFileSpecifaction.automaticallyUpdateViaGit" id="cbspecificationupdatedviagit"
                        (click)="changeCheckBoxValue(assetFileSpecifaction,'automaticallyUpdateViaGit')"></sh-checkbox>
                </div>

                <br>
            </div>
        </div>

        <div *ngIf="!edit" class="modify outline">
            <div>
                <sh-icon slot="functions" button icon="edit" class="edit-asset-icon"
                id="editAssetInfo"
                    (click)="edit = true">
                </sh-icon><br>
                <sh-text class="cursor-pointer edit-asset" (click)="edit = true">Edit asset relatedinfo</sh-text>
            </div>
            <div>
                <sh-icon slot="functions" class="new-version-icon" *ngIf="versionList && versionList.length > 0" button icon="plus"
                    id="AddNewVersion"
                    (click)="newVersion()">
                </sh-icon><br>
                <sh-text class="cursor-pointer new-version" (click)="newVersion()">New version</sh-text>

            </div>
            <div>
                <sh-icon slot="functions" button icon="copy-reference-new"
                    class="new-extension-icon"
                    (click)="newExtension()"></sh-icon><br>
                <sh-text class="cursor-pointer new-extension" id="AddNewExtension" (click)="newExtension()">Add new extension</sh-text>
            </div>
            <div>
                <sh-icon slot="functions" *ngIf="versionList && versionList.length > 0" button icon="export"
                    class="update-asset-icon"
                    (click)="updateAssetFile()"></sh-icon><br>
                <sh-text
                    class="cursor-pointer update-asset" id="UpdateAssetFile" (click)="updateAssetFile()">Update Asset
                    File</sh-text>

            </div>
        </div>

        <!-- <sh-button slot='footer' color='secondary' label='Cancel' id="bcancel"></sh-button>
                <sh-button slot='footer' label='Upload' id="bupload"></sh-button> -->
        <!-- <div>
                <sh-card label='3D Files'>
                    <h1>Hi</h1>
                </sh-card>
            </div> -->
        <!-- <sh-text p>Are you sure you want to delete this file?</sh-text> -->
        <!-- any component can close the modal by removing the 'visible' attribute -->
        <sh-button color='tertiary' slot='footer' label='Cancel'
            onclick="document.getElementById('my-modal').removeAttribute('visible')" id="updateAssetInfoBtnCancel"
            (click)="cancelEdit()"></sh-button>
        <sh-button color='secondary' slot='footer' id="updateAssetInfoBtn" *ngIf="edit" label='Update'
            (click)="updateAsset()"></sh-button>
    </sh-modal>
</div>

<div>
    <div id="overlay" *ngIf="loader">
        <div class="loader">
            <sh-spinner label="Loading"></sh-spinner>
        </div>
    </div>
    <div #rendererContainer></div>
</div>

<sh-modal id="delete-confirmation" type='alert' label='Delete Asset' modal-height='184px' modal-width='450px'>
    <sh-text p>Are you sure you want to delete the asset?</sh-text>
    <sh-button color='tertiary' slot='footer' label='Delete' (click)="deleteAsset()"></sh-button>
    <sh-button color='tertiary' slot='footer' label='Delete version' shape="pill-m" (click)="deleteAssetVersion()"
        *ngIf="validVersions > 1"></sh-button>
    <sh-button color='tertiary' slot='footer' label='Cancel'
        onclick="document.getElementById('delete-confirmation').removeAttribute('visible')"></sh-button>
</sh-modal>